// Comma-separated service ids (e.g. "core,signature") to pause — their CTA shows
// ServiceUnavailableModal instead of starting checkout. Set REACT_APP_PAUSED_SERVICES
// in Vercel env vars and redeploy; no code change needed to pause/resume a service.
const PAUSED_SERVICE_IDS = new Set(
  (process.env.REACT_APP_PAUSED_SERVICES ?? "")
    .split(",")
    .map((id) => id.trim().toLowerCase())
    .filter(Boolean)
);

export function isServicePaused(serviceId: string): boolean {
  return PAUSED_SERVICE_IDS.has(serviceId.toLowerCase());
}
